import {useEffect} from 'react';

interface IProps {
    toastNotificationDisplayTime: number | undefined;
    hideNotification: () => void;
}

const useHideNotification = (props: IProps): void => {
    const {toastNotificationDisplayTime, hideNotification} = props;

    useEffect(() => {
        let notificationTimeout: ReturnType<typeof setTimeout>;

        if (toastNotificationDisplayTime) {
            notificationTimeout = setTimeout(() => {
                hideNotification();
            }, toastNotificationDisplayTime * 1000);
        }

        return () => {
            clearTimeout(notificationTimeout);
        };
    }, []);
};

export default useHideNotification;
